import { cx } from 'cva'
import type { FC } from 'react'
import type { PhaseTagType } from '../../frontend-types'
import { FontAwesomeIcon } from './FontAwesomeIcon'

type PhaseTagProps = {
	phaseTag: PhaseTagType
	cardSize: 'large' | 'small'
}

export const PhaseTag: FC<PhaseTagProps> = ({ phaseTag, cardSize }) => {
	const { icon, phase } = phaseTag
	return (
		<div className="flex items-center gap-x-sm text-blue-shade-70">
			<FontAwesomeIcon icon={icon} size="md" />
			<span className={cx('text-button', cardSize === 'large' ? 'text-button' : 'text-h6')}>
				{phase}
			</span>
		</div>
	)
}
